import { OPERATIONAL_PERMISSIONS } from "../../utils/constants";

function unwrap(groups) {
  if (Array.isArray(groups)) return groups;
  if (Array.isArray(groups?.groups)) return groups.groups;
  return [];
}

export function getNonAdminOperationalGroups(groups) {
  return unwrap(groups).filter(
    (g) =>
      g.name !== "admin" &&
      Array.isArray(g.permissions) &&
      g.permissions.some((p) => OPERATIONAL_PERMISSIONS.includes(p))
  );
}

function memberCount(group, memberCounts) {
  if (memberCounts && group._id != null && group._id in memberCounts) {
    return memberCounts[group._id];
  }
  if (Array.isArray(group.members)) return group.members.length;
  if (typeof group.members === "number") return group.members;
  return 0;
}

export function evaluateSetupStatus(groups, memberCounts) {
  const opGroups = getNonAdminOperationalGroups(groups);
  const groupCreated = opGroups.length > 0;
  const memberAdded = opGroups.some((g) => memberCount(g, memberCounts) >= 1);
  return {
    groupCreated,
    memberAdded,
    setupComplete: groupCreated && memberAdded,
  };
}
